<template>
  <div class="px-2 rounded-lg bg-blue-base text-white text-base font-medium">
    <slot />
  </div>
</template>
